export default __webpack_public_path__ + "static/media/staking-red.649b2e8c.mp4";